export default __webpack_public_path__ + "static/media/frames002.07a279c1.jpeg";